import { apiSlice } from "../api/apiSlice";
import { userLoggedIn } from "./authSlice";

export const authApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        register: builder.mutation({
            query: (data) => ({
                url: "/register",
                method: "POST",
                body: data,
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                try {
                    const result = await queryFulfilled;

                    localStorage.setItem(
                        "auth",
                        JSON.stringify({
                            accessToken: result.data.accessToken,
                            user: result.data.user,
                        })
                    );

                    dispatch(
                        userLoggedIn({
                            accessToken: result.data.accessToken,
                            user: result.data.user,
                        })
                    );
                } catch (err) {
                    // do nothing
                }
            },
        }),
        login: builder.mutation({
            query: ({ role, data }) => ({
                url: "/login",
                method: "POST",
                body: data,
            }),

            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                try {
                    const result = await queryFulfilled;
                    if (arg.role === result?.data?.user?.role ) {
                        localStorage.setItem(
                            "auth",
                            JSON.stringify({
                                accessToken: result.data.accessToken,
                                user: result.data.user,
                            })
                        );

                        dispatch(
                            userLoggedIn({
                                accessToken: result.data.accessToken,
                                user: result.data.user,
                            })
                        );
                    }

                } catch (err) {
                    // do nothing
                }
            },
        }),
        getUsers: builder.query({
            query: ()=>({
                url: "/users"
            })
        })
    }),
});

export const { useLoginMutation, useRegisterMutation, useGetUsersQuery } = authApi;